<template>
  <GenericProgressLinear :icon="'mdi-map-marker'" :title="'Areas'" :stats="stats"></GenericProgressLinear>
</template>


<script>
import { mapGetters } from "vuex"
import GenericProgressLinear from "./GenericProgressLinear"

export default {
  name: "AreasProgressLinear",
  components: { GenericProgressLinear },
  computed: {
    ...mapGetters("entities/areas",["stats"])
  },
};
</script>
